import _ from 'lodash';
import React from 'react';
import autobind from 'autobind-decorator';
import { inject, observer } from 'mobx-react';

import Editor from '../editor';
import EditImage from '../edit-image';
import SongUpload from '../song-upload';

@inject('userStore', 'formStore')
@observer
class AuditionForm extends React.Component {
	constructor (props) {
		super(props);

		this.state = {
			content: ''
		};
	}

	componentDidMount () {
		document.addEventListener('keypress', this.onKeyPress);
	}

	componentWillUnmount () {
		document.removeEventListener('keypress', this.onKeyPress);
	}

	render () {
		const {
			user,
			artist,
			userStore,
			handleImageCrop,
			adminMode
		} = this.props;

		return (
			<div className="grid-x padding-horizontal-1">
				<div className="cell small-5">
					<h4 style={{ textAlign: 'left', fontSize: '1.5rem' }}>
						{
							_.isEmpty(artist.name) ?
								'Your Bio:' : `Your Bio: Tell us about ${artist.name}`
						}
					</h4>
					<Editor
						onBlur={ this.onBioBlur }
						onChange={ this.onBioChange }
						content={ this.state.content } />
				</div>
				<div className="cell small-1"></div>
				<div className="cell small-5">
					<h4 style={{ textAlign: 'left', fontSize: '1.5rem' }}>
						Upload Your Band/Artist Photo:
					</h4>

					<EditImage
						fullWidth
						item={ user }
						handleImageCrop={ handleImageCrop }
					 />
				</div>
			</div>
		);
	}

	@autobind
	onBioChange (content) {
		this.setState({ content });
	}

	@autobind
	onBioBlur () {
		const { artist, formStore } = this.props;
		const { content } = this.state;
		const rawContent = _.isString(content) ? content.replace(/<\/?[^>]+>/g, '') : '';

		formStore.validation = {
			auditionBioForm: _.isEmpty(rawContent) !== true
		};

		artist.bio = content;
	}
}

export default AuditionForm;
